import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Typography } from '@mui/material'

import { useHeader } from '@/hooks/useHeader'
import OnlySupperAdmin from '@/components/UI/OnlySupperAdmin/OnlySupperAdmin'
import IntegrationCard from './IntegrationCard'
import blackboardLogo from '@/assets/images/blackboardnew.png'
import canvasLogo from '@/assets/images/canvas.svg'
import desire2learnLogo from '@/assets/images/brightspace.webp'
import moodleLogo from '@/assets/images/moodle.png'

interface Integration {
  logo: string
  name: string
  description: string
  type: string
}

const integrations: Integration[] = [
  {
    logo: blackboardLogo,
    name: 'Blackboard',
    description:
      'The Blackboard LMS brings efficiency to day-to-day tasks for students and instructors.',
    type: 'blackboard',
  },
  {
    logo: canvasLogo,
    name: 'Canvas',
    description:
      'Canvas LMS simplifies course management, communication, and student connection.',
    type: 'canvas',
  },
  {
    logo: desire2learnLogo,
    name: 'D2L Brightspace',
    description: 'A flexible and powerful learning innovation platform.',
    type: 'desire2learn',
  },
  {
    logo: moodleLogo,
    name: 'Moodle',
    description:
      'Moodle provides a single robust, secure and integrated system to create personalized learning environments',
    type: 'moodle',
  },
]

const Integrations = () => {
  const { t } = useTranslation('translation')
  const { setHeaderText } = useHeader()

  useEffect(() => {
    setHeaderText(t('Integrations'))
  }, [setHeaderText, t])

  return (
    <OnlySupperAdmin>
      <div className="page-mid-wraper integration">
        <div className="interAtions-app tw-mb-6">
          <Typography variant="subtitle1" component="h2">
            {t('Manage Integrations')}
          </Typography>
          <Typography>
            {t('You can manage your connected apps and improve your workflow')}
          </Typography>
        </div>

        <div className="tw-grid tw-gap-4 xl:tw-gap-6 tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 2xl:tw-grid-cols-4">
          {integrations.map(integration => (
            <IntegrationCard
              key={integration.type}
              logo={integration.logo}
              name={t(integration.name)}
              description={t(integration.description)}
              type={integration.type}
            />
          ))}
        </div>
      </div>
    </OnlySupperAdmin>
  )
}

export default Integrations
